function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .gv {\n                clip-path: url(#a);\n            }\n\n            .gw {\n                fill: none;\n                stroke: #000;\n                stroke-linecap: round;\n                stroke-width: 1.5px;\n            }\n        "), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  transform: "translate(8.25 8.292)"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "gv",
  transform: "translate(-8.25 -8.292)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.647,8.25a4.042,4.042,0,0,0-4.037,4.037v7.935a4.037,4.037,0,0,0,8.074.028V12.287A4.042,4.042,0,0,0,17.647,8.25Zm2.355,12a2.355,2.355,0,0,1-4.71-.028V12.287a2.355,2.355,0,1,1,4.71,0Z",
  transform: "translate(2.126 -0.004)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.58,21.438H15.9v3.785H17.58Z",
  transform: "translate(3.034 5.228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.583,23.546h-4.43a.841.841,0,1,0,0,1.682h4.43a.841.841,0,1,0,0-1.682Z",
  transform: "translate(2.405 6.064)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.91,15.817a.841.841,0,0,0-.841.841v.673a5.523,5.523,0,0,1-11.046,0v-.673a.841.841,0,1,0-1.682,0v.673a7.205,7.205,0,1,0,14.411,0v-.673A.841.841,0,0,0,24.91,15.817Z",
  transform: "translate(1.226 2.998)"
}), /*#__PURE__*/React.createElement("path", {
  className: "gw",
  d: "M21.514.548.409,21.521",
  transform: "translate(8.75 8.792)"
}));

function SvgAudioOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOff);
export default __webpack_public_path__ + "static/media/audio_off.f46dd28f.svg";
export { ForwardRef as ReactComponent };